import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScaleChartComponent } from './scale-chart/scale-chart.component';
import { ChartService } from "./services/chart.service";
import { ScaleResultColorService } from './services/scale-result-color.service';
import { ScaleChartLegendComponent } from './scale-chart-legend/scale-chart-legend.component';
import { LegendColorIconComponent } from './legend-color-icon/legend-color-icon.component';
import { SummaryScalesChartComponent } from './summary-scales-chart/summary-scales-chart.component';
import { BaseChartComponent } from './base-chart/base-chart.component';

@NgModule({
  imports: [
    CommonModule
    // ,ChartsModule
  ]
  ,providers: [ChartService, ScaleResultColorService]
  ,declarations: [ScaleChartComponent, ScaleChartLegendComponent, LegendColorIconComponent, SummaryScalesChartComponent]
  ,exports: [ScaleChartComponent, ScaleChartLegendComponent, SummaryScalesChartComponent]
})
export class AssessmentChartsModule { }



// WEBPACK FOOTER //
// ./src/app/assessment-charts/assessment-charts.module.ts